import type { WebClientInfo } from '@ringcentral/rwc-utils/src/types';

const metadata: WebClientInfo =
    typeof window === 'object' && Object.keys(window.webClientInfo || {}).length > 0
        ? window.webClientInfo
        : {
              branch: 'unknown_branch',
              brand: 'rc_us',
              buildNumber: 'unknown_buildNumber',
              commit: 'unknown_commit',
              version: 'unknown_version',
          };

export const METADATA: Readonly<WebClientInfo> = (() => {
    return Object.freeze(metadata);
})();
